import * as React from "react";
const SvgFiRrCheckCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-check-circle_svg__a)">
      <path
        fill="#062147"
        d="M18.214 9.098a1 1 0 0 1-.014 1.414l-4.426 4.345a3.98 3.98 0 0 1-2.8 1.151 3.98 3.98 0 0 1-2.776-1.129l-1.899-1.867a1 1 0 1 1 1.402-1.426l1.893 1.861c.776.75 2.001.746 2.781-.018L16.8 9.085a1 1 0 0 1 1.414.013M24 12c0 6.617-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0s12 5.383 12 12m-2 0c0-5.514-4.486-10-10-10S2 6.486 2 12s4.486 10 10 10 10-4.486 10-10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-check-circle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCheckCircle;
